<script>
import { Bar } from 'vue-chartjs'
import moment from "moment";

export default {
    extends: Bar,

    props: {
        product: {
            type: String
        }
    },

    data: () => ({
        loading: false,
        chartdata: {
            labels: [],
            datasets: [
                {
                    label: 'Qty (Redemption)',
                    backgroundColor: '#1dc9b7',
                    data: []
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false
        }
    }),

    watch: {
        product () {
            this.load()
        }
    },

    async mounted () {
        try {
            await this.load()
        } catch (e) {

        }
    },

    methods: {
        async load() {
            this.loading = true

            try {
                const { data } = await axios.get(`/reports/dashboard/redemption-monthly`, {
                    params: {
                        item_no: this.$props.product ? this.$props.product : null
                    }
                })

                const labels = [];
                const items = [];

                _.orderBy(data.data, 'month').forEach((item) => {
                    labels.push(moment(item.month+'-01').format('MMMM YY'))
                    items.push(item.total)
                })

                this.chartdata.labels = labels
                this.chartdata.datasets[0].data = items

                this.renderChart(this.chartdata, this.options)

            } catch (e) {
                console.log(e)
            }

            this.loading = false
        }
    }
}
</script>
